// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__oGCcs","point":"styles_point__+RFGm","isDragged":"styles_isDragged__Ew6jl"};